import React, { useState } from "react";
import { Button, Tag, Typography } from "antd";
import { SelectOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

export default function SkeyechartsDashboardsTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
}) {
  const env = window._env_ || {};
  const skeyechartPort = env.SKEYECHARTS_PORT || "8088";
  const host = window.location.hostname;
  const protocol = window.location.protocol;
  const skeyechartUrl =
    env.SKEYECHARTS_URL || `${protocol}//${host}:${skeyechartPort}`;

  const [expandedOwners, setExpandedOwners] = useState({});

  const toggleOwnerExpansion = (rowId) => {
    setExpandedOwners((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "15%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Title",
      dataIndex: "dashboard_title",
      key: "dashboard_title",
      width: "20%",
      sorter: (a, b) =>
        (a.dashboard_title || "").localeCompare(b.dashboard_title || ""),
    },
    {
      title: "Owners",
      key: "owners",
      width: "30%",
      render: (_, record) => {
        if (!record.owners || record.owners.length === 0) {
          return (
            <Typography.Text type="secondary" italic>
              No owners
            </Typography.Text>
          );
        }
        const isExpanded = !!expandedOwners[record.id];
        const displayLimit = 1;
        const displayOwners = isExpanded
          ? record.owners
          : record.owners.slice(0, displayLimit);
        const hasMore = record.owners.length > displayLimit;

        return (
          <div>
            {displayOwners.map((owner) => (
              <div key={owner.id} style={{ marginBottom: "4px" }}>
                {owner.first_name} {owner.last_name}
              </div>
            ))}
            {hasMore && (
              <Button
                type="link"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleOwnerExpansion(record.id);
                }}
                style={{ padding: 0, fontSize: "12px" }}
              >
                {isExpanded
                  ? "Show less"
                  : `+${record.owners.length - displayLimit} more`}
              </Button>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "25%",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      render: (status) => (
        <Tag
          color={status === "published" ? "success" : "warning"}
          style={{ fontSize: "12px", padding: "2px 8px" }}
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Button
          type="text"
          icon={<SelectOutlined />}
          onClick={() =>
            window.open(
              `${skeyechartUrl}/skeyechart/dashboard/${record.id}/`,
              "_blank",
              "noopener,noreferrer",
            )
          }
          title="Open Dashboard"
          style={{ color: "#1890ff" }}
        />
      ),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
